export default __webpack_public_path__ + "images/fd59cdfdaba6cbd9c8984fc583ce4da1-theatre_small.webp";